import { Component, Input, OnInit, } from '@angular/core';
import {
  WagtailButtonRendererInterface,
  WagtailPageContentElementInterface,
  WagtailTwoLanRendererInterface
} from "@gea-waldviertler-website/gea-models";
import { v4 as uuidv4 } from "uuid";

export interface StylePropertyInterface {
  [key: string]: string
}

@Component({
    selector: 'wagtail-page-element-two-lan',
    templateUrl: './two-lan.component.html',
    styleUrls: ['./two-lan.component.scss'],
    standalone: false
})
export class WagtailTwoLanComponent implements OnInit {
  @Input() definition?: WagtailPageContentElementInterface<WagtailTwoLanRendererInterface>

  readonly leftImageSizes = '(min-width: 1400px) 746px, (min-width: 1200px) 641px, (min-width: 992px) 536px, (min-width: 768px) 696px, (min-width: 576px) 516px, calc(100vw - 24px)'
  readonly rightImageSizes = '(min-width: 1400px) 526px, (min-width: 1200px) 451px, (min-width: 992px) 376px, (min-width: 768px) 696px, (min-width: 576px) 516px, calc(100vw - 24px)'

  leftButtonDefinition?: WagtailPageContentElementInterface<WagtailButtonRendererInterface>
  rightButtonDefinition?: WagtailPageContentElementInterface<WagtailButtonRendererInterface>

  ngOnInit() {
    if (this.definition) {
      if (this.definition.value.left_button_url) {
        this.leftButtonDefinition = {
          type: "button",
          value: {
            label: this.definition.value.left_button_text,
            url: this.definition.value.left_button_url,
            new_window: false,
            cssClass: "btn-primary mt-2 mb-2"
          },
          id: uuidv4()
        }
      }
      if (this.definition.value.right_button_url) {
        this.rightButtonDefinition = {
          type: "button",
          value: {
            label: this.definition.value.right_button_text,
            url: this.definition.value.right_button_url,
            new_window: false,
            cssClass: "btn-primary mt-2 mb-2"
          },
          id: uuidv4()
        }
      }
    }
  }

  getStyleLeft(): StylePropertyInterface {
    let styles: StylePropertyInterface = {}
    if (this.definition?.value.left_color) {
      styles['color'] = this.definition?.value.left_color
    }

    return styles
  }

  getStyleRight(): StylePropertyInterface {
    let styles: StylePropertyInterface = {}
    if (this.definition?.value.right_color) {
      styles['color'] = this.definition?.value.right_color
    }

    return styles
  }
}
